export {
  default as backyard,
  ReactComponent as Backyard,
} from '@assets/icons/features-and-amenities/backyard.svg'    
